var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentSettings',{staticClass:"pb-10",attrs:{"subtitle":_vm.subtitle,"description":_vm.description},scopedSlots:_vm._u([{key:"center",fn:function(){return [_c('UserProfile')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }